'use client';

import { usePathname } from 'next/navigation';
import { type ReactNode, useLayoutEffect } from 'react';

export default function RouterProvider({
  children,
}: Readonly<{ readonly children: ReactNode }>): ReactNode {
  const pathname = usePathname();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return children;
}
